import { render, staticRenderFns } from "./AverageOrderItems.vue?vue&type=template&id=230f61f4&"
import script from "./AverageOrderItems.vue?vue&type=script&lang=js&"
export * from "./AverageOrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports